import styled from "styled-components";
import {useAppDispatch, useAppSelector} from "../../../hooks";
import React from "react";
import {BackTable} from "../../../features/schemaManageSlice";
import BackTableFieldViewTable, {SqlQuery} from "./BackTableFieldViewTable";
import {useFadeIn} from "../../hooks/useFadeIn";
import BackTableFilterViewTable from "./BackTableFilterViewTable";
import BackTableJoinViewTable from "./BackTableJoinViewTable";
import BackTableUpdViewTable from "./BackTableUpdViewTable";
import BackTableNullsViewTable from "./BackTableNullsViewTable";
import BackTableOuterViewTable from "./BackTableOuterViewTable";
import BackTablePermaFilterViewTable from "./BackTablePermaFilterViewTable";
import AddNew from "./edit/AddNew";
import EditNullableFieldsIcon from "./edit/EditNullableFieldsIcon";

export default function BackTableView({tableName}: { tableName: string }) {
    const table: BackTable = useAppSelector(state => state.schemaManage.back.tables[tableName]);
    const mode = useAppSelector(state => state.schemaManage.back.mode);
    const sqlQuery: string = useAppSelector(state => state.schemaManage.back.sqlSelectQueries[tableName]);
    const staticTable = useAppSelector(state => state.schemaManage.back.staticTables[tableName]);
    const ethereal = useAppSelector(state => state.schemaManage.back.etherealTables[tableName]);
    const dispatch = useAppDispatch();
    const style = useFadeIn({duration: 200});

    return (
        <Container style={style}>
            <h1>{table.name}</h1>

            {(Object.entries(table.fieldsList).length > 0 || mode === "edit") && <Section>
                <SectionTitle>
                    <div>Поля</div>
                    <AddNew tableType={table.type} type={"field"}/>
                </SectionTitle>
                <div className={'sql-select'}>
                    <div className={'sql'}>
                        <SqlQuery sqlQuery={sqlQuery}/>
                    </div>
                </div>
                <BackTableFieldViewTable tableName={tableName} fields={table.fieldsList} joins={table.joins}/>
            </Section>}

            {(Object.entries(table.outerFields).length > 0 || mode === "edit") && <Section>
                <SectionTitle>
                    <div>
                        Зовнішні поля
                    </div>
                    <AddNew tableType={table.type} type={"outerField"}/>
                </SectionTitle>
                {Object.entries(table.outerFields).length > 0 ?
                    <BackTableOuterViewTable tableName={tableName} fields={table.outerFields}/>
                    : <Missing>Відсутні</Missing>}
            </Section>}

            {(Object.entries(table.joins).length > 0 || mode === "edit") && <Section>
                <SectionTitle>
                    <div>Джойни</div>
                    <AddNew tableType={table.type} type={"join"}/>
                </SectionTitle>
                {Object.entries(table.joins).length > 0 ?
                    <BackTableJoinViewTable tableName={tableName} joins={table.joins}/>
                    : <Missing>Відсутні</Missing>}
            </Section>}


            {(Object.entries(table.filtersList).length > 0 || mode === "edit") && <Section>
                <SectionTitle>
                    <div>Фільтри</div>
                    <AddNew tableType={table.type} type={"filter"}/>
                </SectionTitle>
                {Object.entries(table.filtersList).length > 0 ?
                    <BackTableFilterViewTable tableName={tableName} filters={table.filtersList}/>
                    : <Missing>Відсутні</Missing>}
            </Section>}

            {(Object.entries(table.permaFilter).length > 0 || mode === "edit") && <Section>
                <SectionTitle>
                    <div>
                        Постійні фільтри
                    </div>
                    <AddNew tableType={table.type} type={"permaFilter"}/>
                </SectionTitle>
                {Object.entries(table.permaFilter).length > 0 ?
                    <BackTablePermaFilterViewTable tableName={tableName} filters={table.permaFilter}/>
                    : <Missing>Відсутні</Missing>}
            </Section>}


            {(Object.entries(table.updatableFields).length > 0 || mode === "edit") && <Section>
                <SectionTitle>
                    <div>Оновлювані поля</div>
                    <AddNew tableType={table.type} type={"updField"}/>
                </SectionTitle>
                {Object.entries(table.updatableFields).length > 0 ?
                    <BackTableUpdViewTable tableName={tableName} fields={table.updatableFields}/>
                    : <Missing>Відсутні</Missing>}
            </Section>}

            {(table.nullableFields.length > 0 || mode === "edit") && <Section>
                <SectionTitle>
                    <div>Nullable поля</div>
                    <EditNullableFieldsIcon tableType={table.type} />
                </SectionTitle>
                {table.nullableFields.length > 0 ?
                    <BackTableNullsViewTable tableName={tableName} fields={table.nullableFields}/>
                    : <Missing>Відсутні</Missing>}
            </Section>}


        </Container>
    );
}

// Styled Components

const Container = styled.section`
  display: flex;
  flex-direction: column;
  gap: .5rem;
  width: 100%;
  max-width: 1600px;

    color: var(--table-header-text-color);
    
  opacity: 0;
`;


const Missing = styled.span`
  font-size: 1.2rem;
  font-style: italic;
  color: salmon;
  background-color: #0c1118;
  padding: .2rem 1rem;
  border-radius: .2rem;
  width: min-content;
`

const Section = styled.div`
  //padding: 1rem;
  //border: 1px solid var(--table-border-color);
  //border-radius: 0.5rem;
  //background-color: var(--table-header-bg-color);

  display: flex;
  flex-flow: column;
  gap: .5rem;

  .sql-select {
    width: 100%;
    max-width: 100%;
    //display: flex;
    overflow-x: auto;

    .sql {
      max-width: 100%;
      width: 100%;
      overflow-x: auto;
      
      //display: flex;
    }
  }
`;

const SectionTitle = styled.h2`
  color: var(--table-header-text-color);
  font-size: 1.2rem;

  display: flex;
  gap: .5rem;
  align-items: center;
`;
